import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const PageSizeSelector = ({ 
  value, 
  onChange, 
  disabled = false, 
  options = [5, 10, 25, 50],
  label = "Items per page:",
  className = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const selectOption = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = event.target.closest('.custom-page-selector');
      if (!dropdown && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={`page-size-container ${className}`}>
      {label && <span className="page-size-label">{label}</span>}
      <div className={`custom-page-selector ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}>
        <div className="selector-trigger" onClick={toggleDropdown}>
          <span className="selected-value">{value}</span>
          <Icon 
            icon={isOpen ? "iconamoon:arrow-up-2-light" : "iconamoon:arrow-down-2-light"} 
            className="dropdown-arrow"
          />
        </div>
        {isOpen && !disabled && (
          <div className="selector-dropdown">
            {options.map((option) => (
              <div
                key={option}
                className={`dropdown-option ${option === value ? 'selected' : ''}`}
                onClick={() => selectOption(option)}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageSizeSelector;